import { render, staticRenderFns } from "./VendorProfileAbout.vue?vue&type=template&id=6886fe96"
import script from "./VendorProfileAbout.vue?vue&type=script&lang=js"
export * from "./VendorProfileAbout.vue?vue&type=script&lang=js"
import style0 from "./VendorProfileAbout.vue?vue&type=style&index=0&id=6886fe96&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports